/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceItem } from './InvoiceItem';
import {
    InvoiceItemFromJSON,
    InvoiceItemFromJSONTyped,
    InvoiceItemToJSON,
    InvoiceItemToJSONTyped,
} from './InvoiceItem';

/**
 * 
 * @export
 * @interface NewInvoice
 */
export interface NewInvoice {
    /**
     * 
     * @type {Array<InvoiceItem>}
     * @memberof NewInvoice
     */
    items?: Array<InvoiceItem>;
    /**
     * 
     * @type {string}
     * @memberof NewInvoice
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof NewInvoice
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof NewInvoice
     */
    discount?: number;
    /**
     * 
     * @type {Date}
     * @memberof NewInvoice
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof NewInvoice
     */
    dateDue?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof NewInvoice
     */
    sentInEmail?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof NewInvoice
     */
    datePaid?: Date;
    /**
     * 
     * @type {number}
     * @memberof NewInvoice
     */
    cashierId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewInvoice
     */
    cashCollected?: number;
    /**
     * 
     * @type {number}
     * @memberof NewInvoice
     */
    bankTransfer?: number;
    /**
     * 
     * @type {number}
     * @memberof NewInvoice
     */
    cardAmount?: number;
    /**
     * Customer credit balance applied to this invoice as a tender.
     * @type {number}
     * @memberof NewInvoice
     */
    creditApplied?: number;
    /**
     * Money value of the reward points redeemed against this invoice.
     * @type {number}
     * @memberof NewInvoice
     */
    pointsApplied?: number;
    /**
     * Raw count of reward points redeemed against this invoice.
     * @type {number}
     * @memberof NewInvoice
     */
    pointsRedeemed?: number;
    /**
     * 
     * @type {string}
     * @memberof NewInvoice
     */
    referenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof NewInvoice
     */
    collectedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof NewInvoice
     */
    customerId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewInvoice
     */
    businessId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewInvoice
     */
    courierPackageId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewInvoice
     */
    deliveryRequestId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NewInvoice
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof NewInvoice
     */
    deletedOn?: Date;
}

/**
 * Check if a given object implements the NewInvoice interface.
 */
export function instanceOfNewInvoice(value: object): value is NewInvoice {
    return true;
}

export function NewInvoiceFromJSON(json: any): NewInvoice {
    return NewInvoiceFromJSONTyped(json, false);
}

export function NewInvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewInvoice {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(InvoiceItemFromJSON)),
        'status': json['status'] == null ? undefined : json['status'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'discount': json['discount'] == null ? undefined : json['discount'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'dateDue': json['dateDue'] == null ? undefined : (new Date(json['dateDue'])),
        'sentInEmail': json['sentInEmail'] == null ? undefined : json['sentInEmail'],
        'datePaid': json['datePaid'] == null ? undefined : (new Date(json['datePaid'])),
        'cashierId': json['cashierId'] == null ? undefined : json['cashierId'],
        'cashCollected': json['cashCollected'] == null ? undefined : json['cashCollected'],
        'bankTransfer': json['bankTransfer'] == null ? undefined : json['bankTransfer'],
        'cardAmount': json['cardAmount'] == null ? undefined : json['cardAmount'],
        'creditApplied': json['creditApplied'] == null ? undefined : json['creditApplied'],
        'pointsApplied': json['pointsApplied'] == null ? undefined : json['pointsApplied'],
        'pointsRedeemed': json['pointsRedeemed'] == null ? undefined : json['pointsRedeemed'],
        'referenceNumber': json['referenceNumber'] == null ? undefined : json['referenceNumber'],
        'collectedBy': json['collectedBy'] == null ? undefined : json['collectedBy'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'businessId': json['businessId'] == null ? undefined : json['businessId'],
        'courierPackageId': json['courierPackageId'] == null ? undefined : json['courierPackageId'],
        'deliveryRequestId': json['deliveryRequestId'] == null ? undefined : json['deliveryRequestId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deletedOn': json['deletedOn'] == null ? undefined : (new Date(json['deletedOn'])),
    };
}

export function NewInvoiceToJSON(json: any): NewInvoice {
    return NewInvoiceToJSONTyped(json, false);
}

export function NewInvoiceToJSONTyped(value?: NewInvoice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(InvoiceItemToJSON)),
        'status': value['status'],
        'amount': value['amount'],
        'discount': value['discount'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'dateDue': value['dateDue'] == null ? undefined : ((value['dateDue']).toISOString()),
        'sentInEmail': value['sentInEmail'],
        'datePaid': value['datePaid'] == null ? undefined : ((value['datePaid']).toISOString()),
        'cashierId': value['cashierId'],
        'cashCollected': value['cashCollected'],
        'bankTransfer': value['bankTransfer'],
        'cardAmount': value['cardAmount'],
        'creditApplied': value['creditApplied'],
        'pointsApplied': value['pointsApplied'],
        'pointsRedeemed': value['pointsRedeemed'],
        'referenceNumber': value['referenceNumber'],
        'collectedBy': value['collectedBy'],
        'customerId': value['customerId'],
        'businessId': value['businessId'],
        'courierPackageId': value['courierPackageId'],
        'deliveryRequestId': value['deliveryRequestId'],
        'isDeleted': value['isDeleted'],
        'deletedOn': value['deletedOn'] == null ? undefined : ((value['deletedOn']).toISOString()),
    };
}

